import { useSelector } from 'react-redux'
import { FormFieldSqFt } from '../../..'
import { FilterSection } from '../FilterSection'
import { defineMessages, useIntl } from 'react-intl'
import { selectFilter } from '../../../../store/selectors/filters'
import { MIN_SQFT, MAX_SQFT, SQFT_SUFFIX } from '../../../../constants/listings'

import styles from '../Filters.module.scss'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.buildingSize.heading',
    defaultMessage: 'Square Feet'
  },
  min: {
    id: 'General.minimum',
    defaultMessage: 'Minimum'
  },
  max: {
    id: 'General.maximum',
    defaultMessage: 'Maximum'
  }
})

export const BuildingSize = () => {
  const intl = useIntl()
  const filters = useSelector(selectFilter)

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <div className={styles.rangeFields}>
        <FormFieldSqFt
          name={MIN_SQFT}
          suffix={SQFT_SUFFIX}
          allowNegative={false}
          className={styles.rangeField}
          value={filters[MIN_SQFT]}
        >
          {intl.formatMessage(MSG.min)}
        </FormFieldSqFt>
        <div className={styles.dashMark}>—</div>
        <FormFieldSqFt
          name={MAX_SQFT}
          suffix={SQFT_SUFFIX}
          allowNegative={false}
          className={styles.rangeField}
          value={filters[MAX_SQFT]}
        >
          {intl.formatMessage(MSG.max)}
        </FormFieldSqFt>
      </div>
    </FilterSection>
  )
}

BuildingSize.parseValue = (unsafeValue: string) => {
  const unparsedValue = unsafeValue.replace(/[ft²,\s]/g, '')
  return parseFloat(unparsedValue)
}
